var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mobile-nav"},[_c('mobilenav')],1),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column side-nav"},[_c('sidebar')],1),_c('div',{staticClass:"column is-10"},[_c('navbar'),_c('pdf')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }